import axios from 'axios';
import { getLogger } from '../../diagnostics/logger';
import { User, UserManager } from 'oidc-client-ts';
import { Action } from 'redux-actions';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { OIDC_USER_LOADED } from '../../actions/actionTypes';
import { accessTokenExpired, initialAuthention, loadUserError, userLoaded } from '../../actions/loginActions';
import { LoginDetails } from '../../models/loginDetails';
import { AppState } from '../../models/state/appState';
import userManager from '../../services/userManager';

const log = getLogger('simmanagement.sagas.login');

/**
 * Performs the initial load of the current user, if one is stored.
 */
function* userInitFlow() {
  try {
    const user: User | null = yield call(() => userManager.getUser());
    if (user && !user.expired) {
      yield put(userLoaded(user));
    } else if (user && user.expired) {
      log.warn('Found existing user details, but are expired.');
      yield put(accessTokenExpired());
    }
  } catch (error: any) {
    log.error('Error occurred whilst fetching user from store ' + error);
    yield put(loadUserError(error));
  }
}

/**
 * Saga which sets up the HTTP bearer token when the user details are updated.
 * @param action The action which invoked the saga.
 */
function* updateAuthToken(action: Action<User>) {
  if (action.payload) {
    let firstAuth = false;
    if (!axios.defaults.headers.common.Authorization) {
      firstAuth = true;
    }

    axios.defaults.headers.common.Authorization = 'Bearer ' + action.payload.access_token;

    if (firstAuth) {
      yield put(initialAuthention());
    }
  }
}

export function* initLoginSagas() {
  yield takeEvery<Action<User>>(OIDC_USER_LOADED, updateAuthToken);
  yield userInitFlow();
}
